import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import CountAdjFServ02Actions, { CountAdjFServ02Types } from '../Stores/CountAdjFServ02/Actions';

const getAppStore = state => state.app;

export function* countAdjFServ02ShowBatchJobStatus() {
  try {
    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `batchJobStatus/showBatchJobStatus/COUNT_ADJ_F_SERV_02`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(CountAdjFServ02Actions.countAdjFServ02ShowBatchJobStatusSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  }
}

export function* countAdjFServ02Export({ formikBag, criteria }) {
  formikBag.setSubmitting(true);
  try {
    yield put(CountAdjFServ02Actions.countAdjFServ02ExportLoading(true));

    const objCriteria = {};
    if ('doc_date' in criteria) {
      objCriteria.doc_date = criteria.doc_date;
    }
    if ('company_id_select2' in criteria) {
      objCriteria.company_id = criteria.company_id_select2.value;
    }
    if ('location_id_select2' in criteria) {
      objCriteria.location_id = criteria.location_id_select2.value;
    }
    if ('item_ids_select2' in criteria) {
      const values = criteria.item_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.item_ids = values.map(entry => {
          return entry.value;
        });
      }
    }

    const app = yield select(getAppStore);
    const postData = {
      criteria: objCriteria
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `countAdj/fServProcess/COUNT_ADJ_F_SERV_02/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(CountAdjFServ02Actions.countAdjFServ02ExportSuccess());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(CountAdjFServ02Actions.countAdjFServ02ExportLoading(false));
  }
}

export function* countAdjFServ02FetchCompanyOptions({ search }) {
  try {
    yield put(CountAdjFServ02Actions.countAdjFServ02FetchCompanyOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `company/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({ value: d.id, label: `${d.code}` }));

      yield put(CountAdjFServ02Actions.countAdjFServ02FetchCompanyOptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdjFServ02Actions.countAdjFServ02FetchCompanyOptionLoading(false));
  }
}

export function* countAdjFServ02FetchLocationOptions({ search }) {
  try {
    yield put(CountAdjFServ02Actions.countAdjFServ02FetchLocationOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      siteFlowId: app.curSiteFlowId,
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `location/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(CountAdjFServ02Actions.countAdjFServ02FetchLocationOptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdjFServ02Actions.countAdjFServ02FetchLocationOptionLoading(false));
  }
}

export function* countAdjFServ02FetchItemOptions({ search }) {
  try {
    yield put(CountAdjFServ02Actions.countAdjFServ02FetchItemOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `item/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(CountAdjFServ02Actions.countAdjFServ02FetchItemOptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdjFServ02Actions.countAdjFServ02FetchItemOptionLoading(false));
  }
}

export const saga = [
  takeLatest(
    CountAdjFServ02Types.COUNT_ADJ_F_SERV02_SHOW_BATCH_JOB_STATUS,
    countAdjFServ02ShowBatchJobStatus
  ),
  takeLatest(CountAdjFServ02Types.COUNT_ADJ_F_SERV02_EXPORT, countAdjFServ02Export),

  takeLatest(
    CountAdjFServ02Types.COUNT_ADJ_F_SERV02_FETCH_COMPANY_OPTIONS,
    countAdjFServ02FetchCompanyOptions
  ),
  takeLatest(
    CountAdjFServ02Types.COUNT_ADJ_F_SERV02_FETCH_LOCATION_OPTIONS,
    countAdjFServ02FetchLocationOptions
  ),
  takeLatest(
    CountAdjFServ02Types.COUNT_ADJ_F_SERV02_FETCH_ITEM_OPTIONS,
    countAdjFServ02FetchItemOptions
  )
];
